module.exports = __webpack_public_path__ + "static/media/je.a2bead8f.svg";